import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Pagination = ({ totalPages, page, handlePageChange }) => {
    return (
        <div className="pagination">
            <button
                className="chevron"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 1}
            >
                <FaChevronLeft />
            </button>
        
            {Array.from({ length: totalPages }, (_, index) => index + 1)
                .filter((pageNum) => {
                    if (totalPages <= 7) return true;
                    const start = Math.max(1, page - 3);
                    const end = Math.min(totalPages, page + 3);
                    return pageNum >= start && pageNum <= end;
                })
                .map((pageNum) => (
                    <button
                        key={pageNum}
                        onClick={() => handlePageChange(pageNum)}
                        className={`page-button ${page === pageNum ? "active" : ""}`}
                    >
                        {pageNum}
                    </button>
                ))}
        
            <button
                className="chevron"
                onClick={() => handlePageChange(page + 1)}
                disabled={page === totalPages}
            >
                <FaChevronRight />
            </button>
        </div>
    );
}

export default Pagination;